import ZwxScrollbarX from './Index.vue'


ZwxScrollbarX.install = function(Vue) {
  Vue.component(ZwxScrollbarX.name, ZwxScrollbarX)
}


export default ZwxScrollbarX
